<template>
  <div class="tourList">
    <div class="hideOfflineBox">
      <label>
        <input v-model="isHideOffline" type="checkbox" class="hideOffline" />
        WEB受付限定ツアーのみを表示する
      </label>
    </div>

    <div v-if="filteredTours.length === 0" class="no-tours">
      表示可能なツアーはありません。
    </div>

    <div
      v-for="tour in filteredTours"
      :key="tour.code"
      class="tourList_cassette"
    >
      <tour-list-cassette
        :tour="tour"
        :make-detail-page-url="makeDetailPageUrl(tour.sale_type)"
        :mobile="mobile"
        :facets="facets"
        :duration-tabs="durationTabs"
      />
    </div>
  </div>
</template>

<script>
import { Facets } from '@/models'
import TourListCassette from '@/modules/tour-list/components/TourListCassette.vue'

export default {
  name: 'TourList',
  components: {
    TourListCassette,
  },
  props: {
    tours: {
      type: Array,
      required: true,
    },
    makeDetailPageUrl: {
      type: Function, // saleType => tourCode => url
      required: true,
    },
    mobile: {
      type: Boolean,
      default: false,
    },
    facets: {
      type: Facets,
      required: true,
    },
    durationTabs: {
      type: String,
      default: 'always',
    },
  },
  data() {
    return {
      isHideOffline: false,
    }
  },
  computed: {
    allTours() {
      return [...this.tours]
    },
    filteredTours() {
      return this.isHideOffline
        ? this.allTours.filter((tour) => tour.sale_type !== 'offline')
        : this.allTours
    },
  },
}
</script>

<style scoped lang="scss">
.tourList_cassette {
  margin-bottom: 15px;
}
.hideOfflineBox {
  margin-bottom: 16px;
  label {
    cursor: pointer;
  }
  .hideOffline {
    display: inline-block !important;
  }
}
.no-tours {
  margin: 20px 0;
  color: gray;
  text-align: center;
}
</style>
